import maxDifferenceInYearsBetweenDates from './maxDifferenceInYearsBetweenDates'

export default endDate => value => {
  return maxDifferenceInYearsBetweenDates(value, endDate, 2)
}
